// Google Maps data-URI markers cannot resolve application CSS custom
// properties, so their serialized colors live in this single non-component
// module. Keep these values aligned with the --cc-marker-* tokens.
export const mapMarkerPalette = {
  user: '#3267c8',
  userRing: '#2459b8',
  default: '#c5392f',
  tennisRacquet: '#1468a0',
  tennisBall: '#c7f000',
  tennisBallDetail: '#587400',
  star: '#1f7a45',
  heart: '#9f1239',
  dot: '#6b4fc4',
  unavailable: '#68756d',
  white: '#ffffff',
};
